import { render, staticRenderFns } from "./VSIcons.vue?vue&type=template&id=100329ca&"
import script from "./VSIcons.vue?vue&type=script&lang=js&"
export * from "./VSIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports